import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const uploaderApi = createApi({
  baseQuery: customFetchBase({ url: "pa/image" }),
  endpoints: (builder) => ({
    uploadImage : builder.mutation({
      query: (images) => {
        const formData = new FormData();
        for (const img of images) {
          formData.append("file", img);
        }
        return {
          url: "",
          method: "POST",
          body: formData,
        };
      },
    })
  }),
});


export const { useUploadImageMutation  } = uploaderApi